'use strict';

import Block from './components/Block.js';
import Text from './components/Text.js';
import InlineBlock from './components/InlineBlock.js';
import Keyboard from './components/Keyboard.js';
import UpdateManager from './components/core/UpdateManager.js';
import FontLibrary from './components/core/FontLibrary.js';
import * as TextAlign from './utils/inline-layout/TextAlign';
import * as Whitespace from './utils/inline-layout/Whitespace';
import * as JustifyContent from './utils/block-layout/JustifyContent';
import * as AlignItems from './utils/block-layout/AlignItems';
import * as ContentDirection from './utils/block-layout/ContentDirection';

const fontJsonLocation = 'assets/Roboto-msdf.json';
const fontImageLocation = 'assets/Roboto-msdf.png';

const update = () => UpdateManager.update();

const ThreeMeshUI = {
    Block,
    Text,
    InlineBlock,
    Keyboard,
    FontLibrary,
    update,
    TextAlign,
    Whitespace,
    JustifyContent,
    AlignItems,
    ContentDirection
};

//if ( typeof global !== 'undefined' ) global.ThreeMeshUI = ThreeMeshUI;

export {Block};
export {Text};
export {InlineBlock};
export {Keyboard};
export {FontLibrary};
export {update};
export {TextAlign};
export {Whitespace};
export {JustifyContent};
export {AlignItems};
export {ContentDirection};

async function loadJsonData(fontImageTexture) {
    await $.ajax({
        url: fontJsonLocation,
        dataType: 'json',
        success: function (data) {
            keyboardController.keyboardData.setFontJsonData(data);
            ThreeMeshUI.FontLibrary.addFont('Roboto', data, fontImageTexture);
        },
        statusCode: {
            404: function () {
                console.log("Failed to load font json from assets!")
            }
        }
    });
}

async function loadData() {
    const fontImageTexture = await loadTexture(fontImageLocation);
    await loadJsonData(fontImageTexture);
}

loadData();

export default ThreeMeshUI;
